const inOutSine = n => 0.5 * (1 - Math.cos(Math.PI * n));
const noop = () => {};

const makeScroll = prop => {
  return (el, to, opts, cb) => {
    const element = el;
    let callback = cb;
    const options = opts || {};
    const start = Date.now();
    const from = el[prop];
    const ease = inOutSine;
    const duration = Number.isInteger(options.duration)
      ? options.duration
      : 350;
    const requestAnimationFrameCallback = () => {
      callback(null, element[prop]);
    };
    const animate = () => {
      const now = Date.now();
      const time = Math.min(1, (now - start) / duration);
      const eased = ease(time);

      element[prop] = eased * (to - from) + from;

      return time < 1
        ? requestAnimationFrame(animate)
        : requestAnimationFrame(requestAnimationFrameCallback);
    };

    if (typeof opts === 'function') callback = options;
    if (typeof cb !== 'function') callback = noop;

    return requestAnimationFrame(animate);
  };
};
const scrollTop = makeScroll('scrollTop');

export default scrollTop;
